import {
  Countries,
  CurrencySymbol,
  Languages,
} from '@merchant-portal/mp-models'

export const getCountryFromLanguage = language => {
  switch (language) {
    case Languages.NORWEGIAN:
      return Countries.NO
    case Languages.DANISH:
      return Countries.DK
    case Languages.FINNISH:
      return Countries.FI
    case Languages.SWEDISH:
    default:
      return Countries.SE
  }
}

export const getLanguageFromCountry = country => {
  switch (country) {
    case Countries.FI:
      return Languages.FINNISH
    case Countries.DK:
      return Languages.DANISH
    case Countries.NO:
      return Languages.NORWEGIAN
    case Countries.SE:
    default:
      return Languages.SWEDISH
  }
}

export const getCurrencySymbol = country => {
  switch (country) {
    case Countries.FI:
      return new CurrencySymbol({ suffix: '€' })
    case Countries.DK:
      return new CurrencySymbol({ suffix: 'kr.' })
    case Countries.SE:
    case Countries.NO:
    default:
      return new CurrencySymbol({ suffix: 'kr' })
  }
}
